var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpring = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 25 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.87.574-3.42 3.281L12.038 0l-3.42 3.855L5.198.574S-2.82 14.489 11.981 17h.103C26.867 14.49 18.87.574 18.87.574zM24.016 19.526c.3-.987-4.167-.329-4.75-.078-1.249.528-3.585 1.731-4.055 4.561s.154 3.376-.077 3.68c-.231.302 2.832.44 3.961.155a5.78 5.78 0 0 0 2.266-1.07 5.859 5.859 0 0 0 1.61-1.934c1.301-2.155.762-4.38 1.045-5.314zM.044 19.526c-.3-.987 4.168-.329 4.75-.078 1.249.528 3.585 1.731 4.055 4.561s-.154 3.376.077 3.68c.231.302-2.832.44-3.961.155a5.781 5.781 0 0 1-2.266-1.07 5.86 5.86 0 0 1-1.61-1.934C-.17 22.685.326 20.46.043 19.526z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 9.187V31",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpring);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/spring.2f706d32f70294990bd44a8bc27687ed.svg";